import * as yup from 'yup';

export const emailValidation = yup
  .string()
  .email('Email must be valid')
  .nullable()
  .required('Email is required');
